import {Component, ElementRef, QueryList, Renderer2, ViewChild, ViewChildren} from '@angular/core';
import {Content, NavController, NavParams, ViewController} from 'ionic-angular';

import {NavRepository} from "../../../repositories/nav-repository";

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {ImageScroll} from "../../../components/image-scroll/image-scroll";
import {CONFIG} from "../../../app/config";
import {
    ENUM,
    TAction,
    TProdutoTipo,
    TChavecoFlag,
    TContatoTipo,
    TContatoFlag,
    TDevicerBios,
    TFollowup,
    TImageModel,
    TImageSpace,
    TProfileTeam,
    TProfileFlag,
    TProfileSexe,
    TProfileSexo,
    TReceitaFlag,
} from "../../../app/enum";

import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileMenuPage} from "../profile-menu/profile-menu";

import {HotspotLovePage} from "../hotspot-love/hotspot-love";
import {ChavecoMenuPage} from "../chaveco-menu/chaveco-menu";

import {LogadoService} from "../../../providers/logado-service";
import {DataService} from "../../../providers/data-service";
import {MessageService} from "../../../providers/message-service";

import {WebstorSetaPage} from "../webstor-seta/webstor-seta";
import {RolezinMenuPage} from "../rolezin-menu/rolezin-menu";
import {HotspotService} from "../../../providers/hotspot-service";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {MedalhaMenuPage} from "../medalha-menu/medalha-menu";
import {ContatoMenuPage} from "../contato-menu/contato-menu";
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";
import {CentralMenuPage} from "../central-menu/central-menu";
import {FriendyMenuPage} from "../friendy-menu/friendy-menu";
import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {ProfileShipPage} from '../profile-ship/profile-ship';

@Component({
    selector: 'page-profile-page',
    templateUrl: 'profile-page.html',
    providers: [ProfileRepository, ProfileService, HotspotService]
})

export class ProfilePagePage {

    @ViewChild(Content) content: Content;
    @ViewChild('blockwork') blockwork: ElementRef;
    @ViewChildren(ImageScroll) iScrolls: QueryList<ImageScroll>;

    @ViewChild('myImg') myImgg: ElementRef;

    ENUM: any = ENUM;
    config: any;

    TAction: any = TAction;
    TFollowup: any = TFollowup;
    TProfileSexo: any = TProfileSexo;
    TProfileSexe: any = TProfileSexe;
    TProfileFlag: any = TProfileFlag;
    TChavecoFlag: any = TChavecoFlag;
    TContatoTipo: any = TContatoTipo;
    TProfileTeam: any = TProfileTeam;
    TReceitaFlag: any = TReceitaFlag;
    TDevicerBios: any = TDevicerBios;

    TImageModel: any = TImageModel;
    TImageSpace: any = TImageSpace;

    logado: any;
    rootile: any;

    firstCall: boolean;
    extraSelf: boolean;
    extraTeam: boolean;
    extraZito: boolean;
    extraView: boolean;
    enemyView: boolean;

    backwork: any;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public logadoService: LogadoService, public renderer: Renderer2,
                public util: Util, public dataService: DataService, public messageService: MessageService,
                public navRepository: NavRepository,
                public hotspotService: HotspotService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,

                //private atp: AmazingTimePickerService
    ) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.firstCall = true;
        this.extraSelf = false;
        this.extraTeam = false;
        this.extraZito = false;
        this.extraView = false;
        this.enemyView = false;
        this.extraClick(true);

        let profileID = this.util.anyParams(0, this.navParams.get('profileID'), <number>this.dataService.get('param.profileid'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Page', '/profile-page');

        this.profileLoad(profileID);

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    doScroll(event) {

        if (this.content.getScrollElement().scrollTop == 0 || !this.extraSelf) return;
        this.content.scrollTo(0, 0, 1000);
        this.profileLoad(this.rootile.Profile.ProfileID);

    }

    isUpdate(isFriendys?) {

        //Adquiriu Certify em outra Tabpage, atualiza o component
        if (this.iScrolls) {
            let array = this.iScrolls.toArray();
            array.forEach(iscroll => {
                let bool = (iscroll.iscrollArray.length);
                if (bool) setTimeout(() => {

                    let migo = (isFriendys && iscroll.iscrollModel == TImageModel.imProfile);

                    if (!migo) iscroll.update();

                    if (migo) {
                        let abrir = (this.rootile.Friendys.length - (this.rootile._migocount || 4));
                        abrir = (abrir > 16 ? 16 : abrir);

                        let bloco = (abrir / 4);
                        bloco = this.util.roundUp(bloco, 0);

                        this.rootile._migocount = (this.rootile._migocount || 4) + abrir;

                        setTimeout(() => {
                            iscroll.update();
                            if (migo) this.content.scrollTo(0, this.content.getScrollElement().scrollTop + (bloco * 110), 1000);
                        });
                    }


                }, 300);
            });
        }

    }

    profileLoad(profileID: number, event?, force?) {

        let myself = (this.logado.Profile.ProfileID == profileID);

        if (!event && !force && (!profileID || myself)) {
            //GAMBI - ngZone
            //APP-PUBLISH - ngZone
            //RESOLVIDO?
            //profileID = this.logado.Profile.ProfileID;

            this.rootile = this.logado;
            this.refreshTela();
            return;
        }

        let loading = this.util.loadingDots();
        if (!event) loading.present();

        this.profileService.profile(TAction.acLoad, profileID)
            .finally(() => {
                if (event) event.complete();
                loading.dismiss();
            })
            .subscribe(
                data => {

                    if (!myself) this.rootile = data;
                    this.refreshTela();

                },
                erro => {

                    this.util.alertResult(erro);
                    if (this.navCtrl.canGoBack()) this.navCtrl.pop();

                }
            );

    }

    refreshTela(modal?) {

        //So quando sessao expirada, não tem profile logado
        if (!this.rootile || !this.rootile.Profile) return;

        //So quando vem da tela da lista de seguidor e seguindo
        if (modal) modal.that.deleteLine(modal.line);

        //Refresh
        this.enemyView = (this.rootile.Profile && this.rootile.Profile.FriendyMigo == TFollowup.fwInimigo);
        if (this.firstCall) {
            this.firstCall = false;
            this.extraSelf = (this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID);
            this.profileRepository.subscribeFollowupChanged(this.rootile.Profile).subscribe();
            this.subscribeChaveco();

            //#GAMBI - Scroll 1px pois PushRefresh atrapalha o scroll horizontal dos amigos quando colado no topo!
            setTimeout(() => this.content.scrollTo(0, 1, 0), 500);
        }

        if (this.rootile.Friendys) {
            let indexMaxi = (Math.trunc(this.rootile.Friendys.length / 4) * 4);
            this.rootile.Friendys.splice(indexMaxi, 99);
        }

        //Update imageScroll
        this.isUpdate();

        //#GAMBI - Para trocar a cor de acordo com a marca do shadow da imagem
        if (this.rootile.Blendeds && this.rootile.Blendeds.length) {
            setTimeout(() => {
                let corhex = this.config.colors[this.rootile.Blendeds[0].Branded.BrandedCora];
                let corrgb = this.config.hexToRgb(corhex);
                let corstr = corrgb.r + ', ' + corrgb.g + ', ' + corrgb.b;
                if (this.myImgg) this.myImgg.nativeElement.style.filter = 'drop-shadow(0 10px 40px rgb(' + corstr + '))';
            }, 2000);
        }

    }

    profileMenu() {

        let object = {rootile: this.rootile};
        this.navCtrl.push(ProfileMenuPage, object);

    }


    profileShip() {

        if (!this.rootile.Profile.ProfileZitu) return;

        /** 7 - MEMBERSHIP **/
        let object = {etapa: 0, rootile: this.rootile, copyile: this.rootile};
        this.util.modalopen(ProfileShipPage, 'quad', true, object).subscribe();
        
    }

    settingMenu(event) {

        let buttons: Array<any> = [];

        let bloqueado = (this.enemyView ? 'Desbloquear' : 'Bloquear');
        let extrazito   = this.logado.Profile.ProfileZito
        let gabrielWork = (this.logado.Profile.ProfileZito && (this.extraSelf || this.extraTeam));
        let activedFlag = (this.rootile.Profile.ProfileFlag != TProfileFlag.pfGhost);

        /** OPEN **/
        if ( this.extraSelf || this.extraTeam)           buttons.push({text: 'Setting', handler: () => this.profileMenu()});
        if (activedFlag && !this.extraSelf)              buttons.push({text: bloqueado, handler: () => this.friendyMigo(TAction.acLock, this.rootile.Profile)});
        if (activedFlag && !this.extraSelf && extrazito) buttons.push({text: 'Webstor', handler: () => this.navCtrl.push(WebstorSetaPage, {rootile: this.rootile})});
        if (activedFlag && !this.extraSelf && extrazito) buttons.push({text: 'Rolezin', handler: () => this.navCtrl.push(RolezinMenuPage, {rootile: this.rootile})});
        if (activedFlag && gabrielWork)                  buttons.push({text: 'Extras',  handler: () => this.extraClick()});
        if (!this.extraSelf || buttons.length > 1)       buttons.push({text: 'Cancelar', role: 'destructive'});
        this.util.sheetOpen(buttons, this.rootile.Profile.ProfileShow);

        setTimeout(() => event.cancelLoader(), 300);

    }

    profilePage(friendy) {

        let object = {profileID: friendy.ProfileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    contatoFind(contatoRede: TContatoTipo): any {

        return this.rootile.Contatos.find(contato => contato.ContatoRede == contatoRede);

    }

    contatoOpen(contatoRede: TContatoTipo) {

        let contato = this.contatoFind(contatoRede);

        if (contatoRede == TContatoTipo.coChip && (this.extraSelf || !this.extraView || !contato.ContatoUser)) {
            let list = (this.extraSelf && this.rootile.Profile.PrivacyChip);
            this.chavecoMenu(list);
            return;
        }

        let onLove = () => this.chavecoMenu(true);
        if (!this.extraZito || !this.extraView) onLove = null;

        this.profileRepository.contatoOpen(contato, true, null, onLove);

    }

    networkSpot() {

        if (!this.extraSelf) return;

        //Contato NEW - Novo
        let contato = this.contatoFind(TContatoTipo.coOlha);
        if (!contato) {
            contato = {ContatoRede: TContatoTipo.coOlha, ContatoFlag: TContatoFlag.cfNone, ContatoCode: 0, ContatoUser: '', ContatoData: '', ContatoLink: '', ContatoHash: ''};
        }

        let object = {etapa: 1, rootile: this.rootile, copyile: this.rootile, contato: contato};
        this.util.modalopen(ContatoMenuPage, 'alto', false, object).subscribe();

    }

    centralMenu() {

        let objectData = {etapa: 0, rootile: this.rootile};
        this.navCtrl.push(CentralMenuPage, objectData);

    }

    privacyMenu() {

        let copy = this.util.deepCopy(this.logado);

        let object = {etapa: 4, rootile: this.logado, copyile: copy};
        this.util.modalopen(PrivacyMenuPage, 'quad', true, object).subscribe(
            data=> {

                //Reload escondido, acabei de alterar a privacidade carrega para vir dados que nao veio
                if (data.privacyEdit) this.profileLoad(this.rootile.Profile.ProfileID, null, true);

            });

    }

    friendyMenu() {

        let object = {etapa: 0, rootile: this.rootile};
        this.navCtrl.push(FriendyMenuPage, object);

    }

    friendyMigo(action: TAction, profile: any, dontAsk: boolean = false, modal: any = null) {

        let forceTrue = (dontAsk || profile.FriendyMigo != TFollowup.fwSeguidor);
        this.util.alertObserv('CONFIRME', 'Deseja deixar de seguir?', 'Continuar', forceTrue).subscribe(
            () => {

                this.profileRepository.friendy(null, action, profile)
                    .subscribe(
                        data => this.refreshTela(modal),
                        erro => this.util.alertResult(erro)
                    );

            },
            () => {});

    }

    chavecoMenu(list) {

        if (this.extraSelf && !list) {
            let object = {etapa: 0, profile: this.rootile.Profile, chaveco: this.rootile.Chaveco};
            this.navCtrl.push(ChavecoMenuPage, object, {animate: false});
            return;
        }

        let etapa = (list ? 1 : 0);
        let object = {etapa: etapa, profile: this.rootile.Profile, chaveco: this.rootile.Chaveco};
        this.navCtrl.push(ChavecoMenuPage, object, {animate: list});

    }

    hotspotLove() {

        let object = {etapa: 0, rootile: this.rootile};
        this.navCtrl.push(HotspotLovePage, object);

    }

    entrakiOpen() {

        this.util.impact();

        let paybook = this.rootile.Paybooks[0];
        let object = {etapa: 4, checkinSelf: false, paybook: paybook};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe();

    }

    medalhaMenu(medalha: any) {

        if (!medalha) {
            let objectData = {etapa: 0, perfil: this.rootile};
            this.util.modalopen(MedalhaMenuPage, 'alto', false, objectData).subscribe();
            return;
        }

        let objectData = {etapa: 1, perfil: this.rootile, medalha: medalha, filho: medalha.Level-1};
        this.util.modalopen(MedalhaMenuPage, 'quad', true, objectData).subscribe();

    }

    profileTeam() {

        if (!this.extraView && this.rootile.Profile.ProfileShip) {
            this.profileShip();
            return;
        }

        if (!this.logado.Profile.ProfileZito || !this.extraView) return;

        let onTeam = (team) => {

            this.profileService.profile(TAction.acTeam, this.rootile.Profile.ProfileID, null, '&ProfileTeam=' + team)
                .finally(() => this.extraClick())
                .subscribe(
                    data => {
                        this.rootile.Profile.ProfileTeam = team;
                        this.rootile.Profile.ProfileZitu = (this.rootile.Profile.ProfileZito && team == TProfileTeam.mkManager);
                        this.messageService.get('webstor.zera').next(null);
                    },
                    erro => this.util.alertResult(erro)
                );

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        //buttons.push({text: 'Officer', handler: () => onTeam(TProfileTeam.mkOfficer)});
        //buttons.push({text: 'Develop', handler: () => onTeam(TProfileTeam.mkDevelop)});
        buttons.push({text: 'Manager', handler: () => onTeam(TProfileTeam.mkManager)});
        buttons.push({text: 'Partner', handler: () => onTeam(TProfileTeam.mkPartner)});
        buttons.push({text: 'Helping', handler: () => onTeam(TProfileTeam.mkHelping)});
        buttons.push({text: 'Nenhum',  handler: () => onTeam(TProfileTeam.mkNenhum)});
        this.util.sheetOpen(buttons, 'STAFF TEAM');

    }

    meritumOpen(meritum) {

        let object = {etapa: 4, rootile: null, meritums: [meritum], produtoTipo: TProdutoTipo.ptCard};
        this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe(
            data => {
                if (data && data.deleted) {
                    let index = this.rootile.Meritums.indexOf(meritum);
                    if (index >= 0) this.rootile.Meritums.splice(index, 1);

                    //Update imageScroll
                    this.isUpdate();
                }
            }
        );

    }

    backRender(event, varname) {

        this[varname] = event;

    }

    extraClick(start?) {

        this.extraTeam = (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        this.extraZito = (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager && this.logado.Profile.ProfileZito);
        if (start) return;

        this.extraView = !this.extraView;
        this.util.vibrate(50);

        //Update Fundo do Backfull - Coloca como Async
        if (this.backwork) setTimeout(() =>  this.backwork.backRender());

    }

    dismiss() {

        this.navRepository.closePop(this.navCtrl, this.dataService.get('param.profileid'));

    }


    subscribeChaveco() {

        this.messageService.get('chaveco.edit')
            .subscribe(data => {

                if (this.rootile.Profile.ProfileID == data.profile.ProfileID) {
                    this.rootile.Chaveco = data.chaveco;
                }

            });

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-page/profile-page.ts